import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Alert, Glyphicon, Nav, NavItem, Navbar, NavDropdown, Image } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
import './App.css';
import Routes from './Routes';
import RouteNavItem from './components/RouteNavItem';
import { auth } from './libs/auth';
import { permissions } from './libs/permissions';
import logo from './content/de_logo.png';
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';

const App = observer(
  class App extends Component {
    componentDidMount() {
      this.props.store.initialize();
    }

    handleNavLink = event => {
      event.preventDefault();
      this.props.history.push(event.currentTarget.getAttribute('href'));
    };

    handleLogout = event => {
      this.props.store.user.token = null;

      auth.setUserToken(null);

      this.props.history.push('/login');
    };

    renderLoading() {
      return <div>Loading...</div>;
    }

    renderLayout() {
      const childProps = {
        store: this.props.store,
      };
      return (
        <div className="App container">
          <Navbar
            fluid
            collapseOnSelect
            className={this.props.store.page.color}
            style={{ marginTop: '10px' }}
          >
            <Navbar.Header>
              <Link to="/">
                <Image src={logo} alt="Data Energy" responsive style={{ maxHeight: '50px' }} />
              </Link>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav pullRight>
                {this.props.store.user.token ? (
                  [
                    <NavDropdown key="bills" title="Billing" id="nav-billing-dropdown">
                      {permissions.userHasBillingActions(this.props.store.user.groups) && (
                        <RouteNavItem onClick={this.handleNavLink} href="/periodic-bills-due">
                          Periodic Bills Due
                        </RouteNavItem>
                      )}
                      <RouteNavItem onClick={this.handleNavLink} href="/billing-approval-reports">
                        Billing Approval Reports
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/bills">
                        Bills
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/credit_notes">
                        Credit notes
                      </RouteNavItem>
                    </NavDropdown>,
                    <NavDropdown key="properties" title="Properties" id="nav-properties-dropdown">
                      <RouteNavItem onClick={this.handleNavLink} href="/apartments">
                        Apartments
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/buildings">
                        Buildings
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/developments">
                        Developments
                      </RouteNavItem>
                    </NavDropdown>,
                    <NavDropdown key="people" title="People" id="nav-people-dropdown">
                      <RouteNavItem onClick={this.handleNavLink} href="/lessees">
                        Lessees
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/managing_agents">
                        Managing Agents
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/occupants">
                        Occupants
                      </RouteNavItem>
                    </NavDropdown>,
                    <NavDropdown key="agreements" title="Agreements" id="nav-agreements-dropdown">
                      <RouteNavItem
                        onClick={this.handleNavLink}
                        href="/meter_and_billing_agreements"
                      >
                        Meter and Billing Agreements
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/leases">
                        Leases
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/subleases">
                        Sub Leases
                      </RouteNavItem>
                    </NavDropdown>,
                    <NavDropdown key="import" title="Import" id="nav-import-dropdown">
                      <RouteNavItem onClick={this.handleNavLink} href="/import/property/apartments">
                        Import Apartments
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/import/meters">
                        Import Meters
                      </RouteNavItem>
                      <RouteNavItem onClick={this.handleNavLink} href="/import/people">
                        Import People
                      </RouteNavItem>
                    </NavDropdown>,
                    <NavDropdown key="tariff" title="Tariff" id="nav-tariff-dropdown">
                      <RouteNavItem onClick={this.handleNavLink} href="/tariffs">
                        Tariffs
                      </RouteNavItem>
                      {permissions.userHasTariffActions(this.props.store.user.groups) && (
                        <RouteNavItem onClick={this.handleNavLink} href="/tariffs/change">
                          Change Tariff
                        </RouteNavItem>
                      )}
                    </NavDropdown>,
                    <RouteNavItem key="meters" onClick={this.handleNavLink} href="/meters">
                      Meters
                    </RouteNavItem>,
                    <RouteNavItem key="issues" onClick={this.handleNavLink} href="/issues">
                      Issues
                    </RouteNavItem>,
                    <NavItem key="logout" onClick={this.handleLogout}>
                      Logout
                    </NavItem>,
                  ]
                ) : (
                  <RouteNavItem key="login" onClick={this.handleNavLink} href="/login">
                    Login
                  </RouteNavItem>
                )}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          {this.props.store.user.token ? (
            <Alert bsStyle="warning">
            <Glyphicon glyph="alert" style={{marginRight: '1em'}} />
            This site has been placed into read-only operation. All data is viewable, but any create / update / delete
            actions will fail.
            </Alert> ) : ""}
          <Routes childProps={childProps} />
        </div>
      );
    }

    render() {
      return this.props.store.user.isLoading ? this.renderLoading() : this.renderLayout();
    }
  },
);

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js